<script lang="ts">
  import clsx from 'clsx'
  import { formatSecondsToDigitDisplay } from '../../../../utils/Time'
  import { COLORS } from '../../../../const/themes'

  type Props = {
    seconds: number
    style?: string
    isNegative?: boolean
    class?: string
    width?: number
  }

  let {
    seconds,
    style,
    isNegative = false,
    class: className = '',
    width = $bindable(),
  }: Props = $props()
</script>

<div
  bind:clientWidth={width}
  class={clsx(
    'absolute bottom-full mb-2 text-xs bg-black/10 bg-opacity-75 px-1 py-0.5 rounded',
    className,
  )}
  style:color={COLORS.LIGHT}
  {style}
>
  {`${isNegative ? '-' : ''}${formatSecondsToDigitDisplay(seconds)}`}
</div>
